import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-wait-modal',
    templateUrl: './wait-modal.component.html',
    imports: [
        MatDialogModule
    ]
})
export class WaitModalComponent {
    protected readonly dialogRef = inject(MatDialogRef<WaitModalComponent>);

    closeDialog() {
        this.dialogRef.close();
    }
}
